document.addEventListener("DOMContentLoaded", () => {
  // --- GESTION DE LA SIDEBAR (FILTRES DROPDOWN HORIZONTAUX) ---
  const collectionSidebar = document.querySelector("[data-main-collection]");

  if (collectionSidebar) {
    // Clic sur le déclencheur (bouton ou flèche) pour ouvrir / fermer
    collectionSidebar.addEventListener("click", function (event) {
      const triggerBtn = event.target.closest("[data-collapse-icon]");
      const collectionFilterDropdown = event.target.closest("[data-collection-sidebar]");

      if (triggerBtn && collectionFilterDropdown) {
        event.preventDefault();
        event.stopImmediatePropagation();

        const cdIcon = triggerBtn;
        const cdContent = collectionFilterDropdown.querySelector("[data-collapse-content]");
        const isCurrentlyOpen = cdContent ? cdContent.classList.contains("is-open") : false;

        // Fermer tous les autres dropdowns
        const collectionFilterDropdowns = collectionSidebar.querySelectorAll("[data-collection-sidebar]");
        collectionFilterDropdowns.forEach((cd) => {
          const iconThis = cd.querySelector("[data-collapse-icon]");
          const contentThis = cd.querySelector("[data-collapse-content]");
          if (iconThis) {
            iconThis.classList.remove("is-open");
            iconThis.setAttribute("aria-expanded", "false");
          }
          if (contentThis) {
            contentThis.classList.remove("is-open");
            contentThis.style.height = "0";
          }
        });

        // Toggle de l'élément cliqué
        if (!isCurrentlyOpen && cdContent) {
          cdIcon.classList.add("is-open");
          cdIcon.setAttribute("aria-expanded", "true");
          cdContent.classList.add("is-open");
          cdContent.style.height = "max-content";
        }
      }
    }, true);

    // Fermer le dropdown ouvert lors d'un clic à l'extérieur
    document.addEventListener("click", function (event) {
      if (!event.target.closest("[data-collection-sidebar]")) {
        const collectionFilterDropdowns = collectionSidebar.querySelectorAll("[data-collection-sidebar]");
        collectionFilterDropdowns.forEach((cd) => {
          const iconThis = cd.querySelector("[data-collapse-icon]");
          const contentThis = cd.querySelector("[data-collapse-content]");
          if (iconThis) {
            iconThis.classList.remove("is-open");
            iconThis.setAttribute("aria-expanded", "false");
          }
          if (contentThis) {
            contentThis.classList.remove("is-open");
            contentThis.style.height = "0";
          }
        });
      }
    });
  }

  // --- GESTION DE LA DESCRIPTION PRODUIT (PATCHÉ) ---
  const pdDesc = document.querySelector("[data-pd-description]");
  const pdShowBtn = document.querySelector("#pd-show__more");

  // Vérification de sécurité pour éviter l'erreur "addEventListener of null"
  if (pdShowBtn && pdDesc) {
    pdShowBtn.addEventListener("click", function () {
      pdDesc.classList.toggle("active");

      // Change le texte du bouton
      const btnContent = this.querySelector(".content__");
      if (btnContent) {
        if (pdDesc.classList.contains("active")) {
          btnContent.innerText = "Voir moins";
        } else {
          btnContent.innerText = "Voir plus";
        }
      }

      this.classList.toggle("active");
    });
  }
}); // Fin du premier bloc DOMContentLoaded


// --- GESTION DE L'AJOUT AU PANIER (VARIANTS) ---
document.addEventListener("DOMContentLoaded", () => {
  const variantButtons = document.querySelectorAll(".--variant-size");

  if (variantButtons.length > 0) {
    variantButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        const { variant } = btn.dataset;

        let formData = {
          items: [{
            id: variant,
            quantity: 1,
          }],
        };

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
        .then((response) => response.json())
        .then((response) => {
           // Succès - logique supplémentaire si nécessaire
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          // Ouvre le tiroir panier ou met à jour l'icône
          if (typeof theme !== 'undefined' && theme.CartDrawer) {
             new theme.CartDrawer();
          }
          const cartDrawerOpenBtn = document.querySelector(".js-drawer-open-cart");
          if (cartDrawerOpenBtn) {
            cartDrawerOpenBtn.click();
          }
          // Vérifie si la fonction existe avant de l'appeler
          if (typeof updateCartBubble === 'function') {
            updateCartBubble();
          }
        });
      });
    });
  }
});